module.exports = __webpack_public_path__ + "static/media/Whitearrowdown.537ef701.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/extend_nav/Whitearrowdown.svg
// module id = 612
// module chunks = 0